import React from "react";
import ESIPage from "@/components/esi-page/ESIPage";
import { capitalize } from "lodash";

function generateMetadata(params) {
  const title = params?.slug?.[0]?.split("-").map(capitalize).join(" ");
  return {
    title: title || "About Us",
    description:
      "At John Lewis, we're more than just employees. We're owners & that's why we're called Partners & go above & beyond for our customers. Find out more about us.",
  };
}

function Page() {
  return <ESIPage />;
}

Page.generateMetadata = generateMetadata;

export default Page;
